/**
 * Kill switch for the export completion email opt-in.
 *
 * Turned on while outbound email could not reach customer addresses, so that nobody opted into
 * something that silently did nothing. Off again now that sending works. Kept rather than
 * reverted, so the checkbox can be pulled at once if deliverability is ever in doubt.
 */
export const EXPORT_NOTIFICATIONS_DISABLED = false;

/** Shown on the disabled checkbox. Deliberately generic - no infrastructure detail. */
export const EXPORT_NOTIFICATIONS_DISABLED_MESSAGE =
  'Email notifications are temporarily unavailable. Your export will run as normal - the result appears on this page when it finishes.';
